import apiClient from '@/lib/axios';
import type { JobCost, CostSummary, CreateJobCostRequest, CostCategory } from '../types/jobCost';

/**
 * Get all costs for a job
 */
export const getJobCosts = async (jobId: number, isForecast?: boolean): Promise<JobCost[]> => {
  const params = new URLSearchParams();
  if (isForecast !== undefined) {
    params.append('isForecast', isForecast.toString());
  }

  const response = await apiClient.get<{ data: JobCost[] }>(
    `/jobs/${jobId}/costs${params.toString() ? `?${params.toString()}` : ''}`
  );
  return response.data.data;
};

/**
 * Get cost summary totals for a job
 */
export const getJobCostSummary = async (
  jobId: number,
  isForecast?: boolean
): Promise<CostSummary> => {
  const params = new URLSearchParams();
  if (isForecast !== undefined) {
    params.append('isForecast', isForecast.toString());
  }

  const response = await apiClient.get<{ data: CostSummary }>(
    `/jobs/${jobId}/costs/summary${params.toString() ? `?${params.toString()}` : ''}`
  );
  return response.data.data;
};

/**
 * Get all cost categories
 */
export const getCostCategories = async (): Promise<CostCategory[]> => {
  const response = await apiClient.get<{ data: CostCategory[] }>('/cost-categories');
  return response.data.data;
};

/**
 * Create a new job cost
 */
export const createJobCost = async (
  jobId: number,
  data: CreateJobCostRequest
): Promise<JobCost> => {
  const response = await apiClient.post<{ data: JobCost }>(`/jobs/${jobId}/costs`, data);
  return response.data.data;
};

/**
 * Update an existing job cost
 */
export const updateJobCost = async (
  jobId: number,
  costId: number,
  data: CreateJobCostRequest
): Promise<JobCost> => {
  const response = await apiClient.put<{ data: JobCost }>(`/jobs/${jobId}/costs/${costId}`, data);
  return response.data.data;
};

/**
 * Delete a job cost
 */
export const deleteJobCost = async (jobId: number, costId: number): Promise<void> => {
  await apiClient.delete(`/jobs/${jobId}/costs/${costId}`);
};
